<template>
    <b-container class="bg-light" style="min-height: 700px">
            <b-row class="d-flex justify-content-center pt-3">  
                <ul class="list-unstyled">
                    <li v-if="institute">
                        <h4 class="font-weight-light">
                        <img :src="institute.image" alt="" style="max-width: 100px">
                        {{ institute.name }}
                        </h4>
                    </li>
                </ul>
            </b-row>
            <b-card no-body>
                <b-tabs pills card v-if="courses && checkDisabled">
                    <div v-for="tab in tabs" :key="tab">
                        <b-tab :active="tab === checkDisabled[0]"
                               :disabled="!checkDisabled.includes(tab)"
                               :title="'Level ' + tab">
                            <table class="table table-striped table-borderless">
                                <thead>
                                    <tr>
                                        <th scope="col"><h5>Course Name</h5></th>
                                        <th scope="col"><h5>Credits</h5></th>
                                        <th scope="col"><h5>Duration</h5></th>
                                    </tr>
                                    </thead>
                                <tbody>
                                        <tr v-for="course in courses" v-if="tab === course.mnqf.level">    
                                            <td scope="row">
                                                <router-link :to="{ name: 'course', params: { institute_id: institute.id, course_id: course.id } }" style="text-decoration: none !important">{{ course.name }}</router-link>
                                            </td>
                                            <td scope="row" class="table-cell">
                                                <router-link :to="{ name: 'course', params: { course_id: course.id } }" style="text-decoration: none !important">{{ course.credits }}</router-link>
                                            </td>
                                            <td scope="row" class="table-cell">
                                                <router-link :to="{ name: 'course', params: { course_id: course.id } }" style="text-decoration: none !important">{{ course.duration }}</router-link>
                                            </td>
                                        </tr>
                                </tbody>
                            </table>
                        </b-tab>
                    </div>
                </b-tabs>
            </b-card>
    </b-container>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return{
            courses: null,
            institute: null,
            tabs: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        }
    },
    methods: {
        getInstitute() {
            let path = this.API_URL + '/institutes/' + this.$route.params.institute_id
            axios.get(path).then((response) => {
                this.institute = response.data
                // Update page title here because it's dynamic
                // Otherwise this will fail horribly
                document.title = this.institute.name + ' Courses'
            }, (error) => {
                console.log(error)
            });
        },

        getCourses() {
            axios.get(this.API_URL + '/institutes/' + this.$route.params.institute_id + '/courses').then((response) => {
                this.courses = response.data
            }, (error) => {
                console.log(error)
            });
        }
        
    },
    computed: {
        checkDisabled(){
            let isDisabled = []
            if (this.courses) {
                this.tabs.forEach((element) => {
                    isDisabled.push((this.courses.filter((course) => 
                        course.mnqf.level === element
                    )[0]) ? element : false) 
                })
                return isDisabled.filter(disabled => disabled ? disabled : null)
            }
        }
    },
    beforeCreate() {
        
    },
    created() {

    },
    beforeMount() {
        this.getInstitute();
        this.getCourses();
    },
    mounted() {
        console.log(this.checkDisabled)
        
    },
    beforeUpdate() {
        
    },
    updated() {
        
    }
}
</script>
<style scoped>
td a { 
    display: block; 
}
</style>



// WEBPACK FOOTER //
// src/components/institute.vue